<template>
  <div class="detail-info">
    <div class="detail-info__shadow"></div>
    <div class="detail-info__content">
      <div class="detail-info__poster">
        <img v-if="movie.poster" class="detail-info__poster-img" :src="movie.poster" alt="" />
        <div v-else class="detail-info__poster-placeholder"></div>
      </div>
      <div class="detail-info__info">
        <div class="detail-info__top">
          <h1 class="detail-info__title">{{ movie.title }}</h1>
          <div class="detail-info__tags">
            <div v-for="(tag, index) in movie.genres" :key="index" class="detail-info__tag">
              {{ tag }}
            </div>
          </div>
          <div class="detail-info__meta">
            <div class="detail-info__rating">
              <img class="detail-info__star" src="@/assets/icon/star-dark.svg" />
              <div class="detail-info__score">{{ Number(movie.score).toFixed(1) }}</div>
            </div>
            <div class="detail-info__date">{{ movie.year || '' }}</div>
            <div class="detail-info__runtime" v-if="formattedRuntime">{{ formattedRuntime }}</div>
          </div>
          <!-- <div class="detail-info__countries">
            <div class="detail-info__country">United States</div>
            <div class="detail-info__separator"></div>
            <div class="detail-info__language">English</div>
            <div class="detail-info__separator"></div>
            <div class="detail-info__rating-text">PG-13</div>
            <div class="detail-info__separator"></div>
            <div class="detail-info__platforms">Netflix · Apple TV+ · Disney Plus</div>
          </div> -->
          <div class="detail-info__description">{{ movie.description }}</div>
          <div class="detail-info__credits">
            <div class="detail-info__director">
              <div class="detail-info__director-label">director</div>
              <div class="detail-info__director-name">{{ movie.director }}</div>
            </div>
            <div class="detail-info__credits-separator"></div>
            <div class="detail-info__actors">
              <div class="detail-info__actors-label">actor</div>
              <div class="detail-info__actors-names">{{ movie.stars }}</div>
            </div>
          </div>
        </div>
        <div class="detail-info__watch" role="button" tabindex="0"
          @click="$emit('watch')" @keyup.enter="$emit('watch')" @keyup.space="$emit('watch')">
          <img class="detail-info__play" src="@/assets/icon/play-circle.svg" />
          <div class="detail-info__watch-text">Watch Trailer</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailInfo',
  props: {
    movie: {
      type: Object,
      default: () => ({
        title: '',
        poster: '',
        genres: [],
        score: '',
        date: '',
        runtime: '',
        number_of_episodes: '',
        description: '',
        director: '',
        writers: '',
        stars: ''
      })
    }
  },
  computed: {
    formattedRuntime () {
      if (this.movie.runtime) {
        // 电影运行时间处理
        const runtime = parseInt(this.movie.runtime);
        if (isNaN(runtime)) return this.movie.runtime;

        // 如果是数字，格式化为 "XX min"
        return `${runtime} min`;
      } else if (this.movie.number_of_episodes) {
        // 电视剧集数处理
        const episodes = parseInt(this.movie.number_of_episodes);
        if (isNaN(episodes)) return this.movie.number_of_episodes;

        // 如果是数字，格式化为 "XX eps"
        return `${episodes} EPs`;
      }
      return '';
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.detail-info {
	position: relative;
	width: 100%;
	background-image: var(--bg-image);
	background-size: cover;
	background-position: center;

	&__shadow {
		background: linear-gradient(180deg, #0d0c0f 0%, rgba(13, 12, 15, 0.9) 30.35%, rgba(13, 12, 15, 0.7) 50%, rgba(13, 12, 15, 0.9) 70.25%, #0d0c0f 100%);
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	&__content {
		display: flex;
		flex-direction: row;
		gap: rem(44);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		padding: rem(44) rem(80);
		z-index: 1;
	}

	&__poster {
		flex-shrink: 0;
		width: rem(268);
		height: rem(402);
		position: relative;
	}

	&__poster-img {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__poster-placeholder {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		background-color: rgba(255, 255, 255, 0.05);
	}

	&__info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
		height: rem(402);
		position: relative;
	}

	&__top {
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(32);
		line-height: rem(40);
		font-weight: 900;
		position: relative;
		align-self: stretch;
	}

	&__tags {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
		position: relative;
	}

	&__tag {
		border-radius: rem(8);
		border: 1px solid rgba(255, 255, 255, 0.2);
		padding: rem(4) rem(8);
		color: #ffffff;
		font-size: rem(12);
		line-height: rem(14);
		font-weight: 400;
		opacity: 0.6;
		position: relative;
	}

	&__meta {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__rating {
		background: #ffaf00;
		border-radius: rem(8);
		padding: rem(3) rem(8);
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__star {
		width: rem(12);
		height: rem(12);
	}

	&__score {
		color: #0d0c0f;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		text-transform: uppercase;
		position: relative;
	}

	&__date {
		background: #fe324b;
		border-radius: rem(8);
		padding: rem(4) rem(8);
		color: #ffffff;
		font-size: rem(12);
		line-height: rem(14);
		font-weight: 500;
		position: relative;
	}

	&__runtime {
		background: #b132fb;
		border-radius: rem(8);
		padding: rem(4) rem(8);
		color: #ffffff;
		font-size: rem(12);
		line-height: rem(14);
		font-weight: 500;
		position: relative;
	}

	&__countries {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__country,
	&__language,
	&__rating-text,
	&__platforms {
		color: #ffffff;
		font-size: rem(13);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
	}

	&__separator {
		background: #ffffff;
		opacity: 0.1;
		width: 1px;
		height: rem(20);
		position: relative;
	}

	&__description {
		color: #ffffff;
		text-align: left;
		font-size: rem(13);
		line-height: rem(20);
		font-weight: 400;
		opacity: 0.4;
		position: relative;
		align-self: stretch;
	}

	&__credits {
		display: flex;
		flex-direction: row;
		gap: rem(36);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
	}

	&__director,
	&__actors {
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}

	&__director-label,
	&__actors-label {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
		align-self: stretch;
	}

	&__director-name,
	&__actors-names {
		color: #ffffff;
		font-size: rem(13);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
		align-self: stretch;
	}

	&__credits-separator {
		background: #ffffff;
		opacity: 0.1;
		width: 1px;
		height: rem(40);
		position: relative;
	}

	&__watch {
		background: #fe324b;
		border-radius: 100px;
		padding: rem(12) rem(16);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
		align-self: flex-start;

		&:focus-visible {
			outline: 2px solid #ffffff;
			outline-offset: rem(2);
		}
	}

	&__play {
		width: rem(20);
		height: rem(20);
	}

	&__watch-text {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.detail-info {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.detail-info {
		&__content {
			flex-direction: column;
			padding: rem(20) rem(16);
			gap: rem(24);
		}

		&__poster {
			width: 100%;
			height: auto;
			aspect-ratio: 2/3;
			max-width: rem(240);
			margin: 0 auto;
		}

		&__info {
			width: 100%;
			height: auto;
			gap: rem(24);
		}

		&__top {
			gap: rem(12);
		}

		&__title {
			text-align: center;
			font-size: rem(32);
		}

		&__tags {
			justify-content: center;
		}

		&__meta {
			justify-content: center;
		}

		&__countries {
			flex-wrap: wrap;
			justify-content: center;
		}

		&__platforms {
			margin-top: rem(12);
		}

		&__description {
			margin-top: rem(12);
		}

		&__credits {
			flex-direction: column;
			align-items: flex-start;
			gap: rem(24);
			margin-top: rem(12);
		}

		&__credits-separator {
			display: none;
		}

		&__director,
		&__actors {
			width: 100%;
		}

		&__watch {
			width: 100%;
			justify-content: center;
			margin-top: rem(12);
			gap: rem(20);
		}
	}
}
</style>
